import { PAYMENT_PROCESSOR } from 'components/UserPaymentForm/utils';

const prepareCards = ({ renewInfo, paymentProcessor }) => {
	if (paymentProcessor === PAYMENT_PROCESSOR.stripe) {
		return renewInfo.card_details.map(details => ({
			details,
			...details.card,
			card_brand: details.card.brand,
			last_4: details.card.last4
		}));
	}

	return [...renewInfo.card_details];
};

const prepareRenewInfoCardFile = ({ renewInfo, paymentProcessor }) => {
	let _memberTypes = [];
	let _cardsOnFile = [];
	let _memberInstance = {};

	if (renewInfo.user?.member_types) {
		_memberTypes = [...renewInfo.user.member_types];
	}

	if (renewInfo.card_details) {
		_cardsOnFile = prepareCards({ paymentProcessor, renewInfo });
	}

	if (renewInfo.member) {
		_memberInstance = {
			...renewInfo.member
		};
	}

	return [_memberTypes, _cardsOnFile, _memberInstance];
};

export default prepareRenewInfoCardFile;
